export class PluginRegistry {
    constructor() {
        this.registeredPlugins = {};
        this.completeLoadListeners = [];
        this.bound = false;
        this.studio = undefined;
        this.locators = {};
    }

    getOrDefault(obj, key, defaultValue) {
        if (!obj) {
            return defaultValue;
        }
        const val = obj[key];
        if (val !== undefined && val !== null) {
            return val;
        } else {
            return defaultValue;
        }
    }

    run() {
        this.completeLoadListeners.forEach(handler => {
            handler(this.locators);
        });
    }

    onPluginInitComplete(callback) {
        if (typeof callback === "function") {
            this.completeLoadListeners.push(callback);
        }
    }

    register(plugin, options, errorCallBack) {
        let defaultOptions = {
            customLauncher: this.getOrDefault(options, 'customLauncher', false),
            configResolver: this.getOrDefault(options, 'configResolver', false)
        };

        let handleError = (code, message) => {
            if (errorCallBack !== undefined && typeof errorCallBack === 'function') {
                errorCallBack(code, message);
            }
        };

        // plugin needs to have a name
        if (plugin.name === undefined) {
            // TODO throw error
            handleError(0,"plugin_no_name");
            return false;
        }

        // there must be an init method
        if (typeof plugin.init !== "function") {
            handleError(1, "plugin_no_init_function");
            return false;
        }

        // plugin must be disposable
        if (typeof plugin.dispose !== "function") {
            handleError(2, "plugin_no_dispose_function");
        }

        console.log("Registering new Plugin", plugin.name);

        // insert plugin into registry
        this.registeredPlugins[plugin.name] = {
            hasLauncher: defaultOptions.customLauncher,
            providesConfig: defaultOptions.configResolver,
            plugin,
            running: false
        };

        // check if this plugin provides config, if yes, chain them in registration order
        // at first, we cannot provide config if studio is already bound
        if (defaultOptions.configResolver) {
            if (typeof plugin.getConfig !== 'function') {
                handleError(3, "plugin_config_resovler_no_impl_func");
            } else if (this.bound){
                handleError(4, "plugin_config_resovler_studio_already_bound");
            } else {
                if (!this.locators.config) {
                    this.locators.config = [];
                }

                this.locators.config.push(this.registeredPlugins[plugin.name]);
            }
        }

        // if plugins are bound
        if (this.bound) {
            this.registeredPlugins[plugin.name].plugin.init(this.studio);
            this.registeredPlugins[plugin.name].running = true;
        }

        // if no earlier return was fired, everything went well
        return true;
    }

    unregister(plugin) {
        
        let name = undefined;
        if (typeof plugin === "string") {
            name = plugin;
        } else if (typeof plugin === "object") {
            name = plugin.name;
        }

        if (name !== undefined) {
            let registeredPlugin = this.registeredPlugins[name];
            if (registeredPlugin !== undefined) {
                // unregister first
                if (this.bound && registeredPlugin.running) {
                    registeredPlugin.plugin.dispose();
                } 

                // remove from the list
                delete this.registeredPlugins[name];
            }
        } else {
            // ERROR no name found 
            console.log("given", plugin, "was not found in registry");
        }
    }

    bindStudio(studio) {
        
        // if studio is already bound, dispose all running plugins 
        this.unbindStudio();
        this.studio = studio;
        // bind studio to all plugins
        Object.keys(this.registeredPlugins).forEach(k => {
            var plugin = this.registeredPlugins[k];
            plugin.running = true;
            plugin.plugin.init(this.studio);
        });

        this.bound = true;
    }

    unbindStudio() {
        if (this.bound) {
            Object.keys(this.registeredPlugins).forEach(k => {
                let plugin = this.registeredPlugins[k];
                plugin.plugin.running = false;
                plugin.plugin.dispose();
            });
            this.bound = false;
        }
    }
}



// WEBPACK FOOTER //
// ./src/js/define/PluginRegistry.js